export const filmAdaptations = [
  {
    id: "shao",
    title: "邵氏片厂时期的古装片",
    era: "20世纪60—70年代",
    meta: "香港地区 / 古装",
    desc:
      "香港片厂制度兴盛时期，多家公司把《水浒传》与《金瓶梅》中的人物故事搬上银幕，武打与市井两条路线并行，潘金莲常作为支线人物出现。",
  },
  {
    id: "novel-film",
    title: "《潘金莲之前世今生》",
    era: "1989年",
    meta: "香港地区 / 文艺改编",
    desc:
      "据作家李碧华同名小说改编，以“前世今生”的轮回结构重写潘金莲，把古典人物放进现代都市处境，是这一题材中偏向文艺路线的代表。",
  },
  {
    id: "nineties",
    title: "九十年代的系列化影片",
    era: "1990年代",
    meta: "港台地区 / 系列",
    desc:
      "这一时期出现多部以《金瓶梅》人物为核心的系列化商业影片，片名相近、续集不断，类型化与娱乐化特征明显。",
  },
  {
    id: "network",
    title: "当代网络电影与数字发行",
    era: "2000年代以后",
    meta: "院线以外 / 网络",
    desc:
      "随着数字发行兴起，不少网络电影沿用人物名号进行轻量改编，制作规模与叙事长度较传统影片更为精简。",
  },
];

export const tvAdaptations = [
  {
    id: "cctv",
    title: "央视版《水浒传》",
    era: "1998年",
    meta: "内地 / 名著改编",
    desc:
      "改编自《水浒传》的长篇剧集，以群像方式叙述梁山故事，潘金莲为其中一条重要支线人物，篇幅上得到了更充分的展开。",
  },
  {
    id: "remake",
    title: "内地重拍版《水浒传》",
    era: "2011年前后",
    meta: "内地 / 重拍",
    desc:
      "新一轮重拍对人物造型与情感动机做了新的处理，潘金莲一角再度成为观众讨论的焦点，也带动了该题材的重新检索。",
  },
  {
    id: "jinpingmei-tv",
    title: "《金瓶梅》题材剧集",
    era: "不同年代",
    meta: "多地版本 / 人物剧",
    desc:
      "以《金瓶梅》人物为主线的电视剧在不同地区陆续出现，篇幅与侧重各不相同，有的偏人物关系，有的偏市井风俗。",
  },
  {
    id: "unit",
    title: "单元剧与情景改编",
    era: "各地版本",
    meta: "单元叙事 / 家庭",
    desc:
      "部分剧集把潘金莲故事处理为单元叙事，围绕家庭与市井关系展开，单集独立成篇，便于零散观看与检索。",
  },
];